var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1545 0H5.06776C4.64878 0 4.30908 0.338871 4.30908 0.7569V4.22788H11.1545V0Z",
    fill: "#1CAF83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0002 4.22852H11.1548V8.00102H18.0002V4.22852Z",
    fill: "#1CAF83"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0002 4.22788V0.7569C18.0002 0.338871 17.6606 0 17.2415 0H11.1548V4.22788H18.0002Z",
    fill: "#1EBB8C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1545 4.22852H4.30908V8.00102H11.1545V4.22852Z",
    fill: "#148865"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1545 8H4.30908V11.7784H11.1545V8Z",
    fill: "#107053"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0002 8H11.1548V11.7784H18.0002V8Z",
    fill: "#148865"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1548 15.9993H17.2415C17.6605 15.9993 18.0002 15.6604 18.0002 15.2424V11.7773H11.1548V15.9993V15.9993Z",
    fill: "#107053"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.30908 11.7774V15.2424C4.30908 15.6605 4.64872 15.9993 5.06776 15.9993H11.1545V11.7773H4.30908V11.7774Z",
    fill: "#107053"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.36469 3.41992H0.842715C0.377296 3.41992 0 3.79636 0 4.26072V11.7656C0 12.23 0.377296 12.6064 0.842715 12.6064H8.36469C8.83011 12.6064 9.20741 12.23 9.20741 11.7656V4.26072C9.20741 3.79636 8.83011 3.41992 8.36469 3.41992Z",
    fill: "#148865"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.91884 10.5252L5.168 7.97887L6.83114 5.52734H5.67943L4.58975 7.13409L3.4876 5.52734H2.33595L4.01805 7.97664L2.28809 10.5252H3.43979L4.5974 8.81973L5.76713 10.5252H6.91884Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.f7fd44e54add0c4e2abe958dfaabdfc3.svg";
export { ForwardRef as ReactComponent };